import { EventsList } from '../../../components/Events/EventsList'

export const EventsRepliesPage = () => <EventsList scope="replies" />
